import { http } from '@Techedge/digitalportal-shared'
import {
	StreamingResponse,
	StartConversationRequest,
	StartConversationResponse,
} from '../services/types'

export class ChatbotService {
	static async sendStreamingMessage(
		message: string,
		language: string,
		conversationId: string,
		username: string
	): Promise<StreamingResponse> {
		return http.post(
			`${process.env.REACT_APP_BASE_URL_BE}/filtersapi/chatbotai/chatbot-stream-msg`,
			{
				message,
				stream: true,
				language,
				return_docs: false,
				conversation_id: conversationId,
				username,
			},
			{
				headers: {
					'Content-Type': 'application/json',
				},
				responseType: 'stream',
			}
		) as Promise<StreamingResponse>
	}

	static async startConversation(
		language: string
	): Promise<StartConversationResponse> {
		const requestBody: StartConversationRequest = {
			language,
			stream: false,
			return_docs: false,
		}

		const response = await http.post(
			`${process.env.REACT_APP_BASE_URL_BE}/filtersapi/chatbotai/chatbot-start`,
			requestBody,
			{
				headers: {
					'Content-Type': 'application/json',
				},
			}
		)

		if (response.status !== 200) {
			throw new Error('Errore nella risposta del server')
		}

		return response.data as StartConversationResponse
	}
}
